import React, {Component} from 'react';
import "./main_paragraph.scss";
import {insertHtml} from "../../utils/dom";


interface MainParagraphProps {
    title?: string;
    text?: string;
}

class MainParagraph extends Component<MainParagraphProps> {

    render() {
        if (!this.props.title && !this.props.text) {
            return <div />;
        }

        return (
            <div className="main-paragraph">
                {this.props.title &&
                    <h3 className="component-title">{this.props.title}</h3>
                }
                {this.props.text &&
                    <p className="text editor-html" {...insertHtml(this.props.text)} />
                }
            </div>
        );
    }
}

export default MainParagraph;
